import HttpFactory from "~/repository/factory";
import { ENDPOINTS } from "~/repository/endpoints";
import type {
  AdminCampaign,
  CampaignListFilters,
  CampaignSubmissionDetail,
  CampaignSubmissionFilters,
  CampaignSubmissionListItem,
  CampaignsPaginatedResponse,
} from "~/types/admin/campaigns";

class AdminCampaignsModule extends HttpFactory {
  async getCampaigns(
    filters: CampaignListFilters = {},
  ): Promise<CampaignsPaginatedResponse<AdminCampaign>> {
    return await this.get(ENDPOINTS.ADMIN.CAMPAIGNS.LIST, filters);
  }

  async getSubmissions(
    filters: CampaignSubmissionFilters = {},
  ): Promise<CampaignsPaginatedResponse<CampaignSubmissionListItem>> {
    return await this.get(ENDPOINTS.ADMIN.CAMPAIGNS.SUBMISSIONS, filters);
  }

  async getSubmission(submissionId: string): Promise<CampaignSubmissionDetail> {
    const encodedSubmissionId = encodeURIComponent(submissionId);

    return await this.get(
      `${ENDPOINTS.ADMIN.CAMPAIGNS.SUBMISSIONS}${encodedSubmissionId}/`,
    );
  }

  async exportSubmissionsCsv(
    filters: CampaignSubmissionFilters = {},
  ): Promise<Blob> {
    return await this.get(
      ENDPOINTS.ADMIN.CAMPAIGNS.SUBMISSIONS_EXPORT_CSV,
      filters,
      { responseType: "blob" },
    );
  }
}

export default AdminCampaignsModule;
